import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../../../constants';
import { getMembersAreaPage } from '../../../wrappers/pages';
import type { OpenAddTabsPanelPayload } from '../../../wrappers/panels';
import { openAddTabsPanel } from '../../../wrappers/panels';

export const handleAddTabs = async (editorSDK: EditorSDK, eventPayload: OpenAddTabsPanelPayload = {}) => {
  const membersAreaPage = await getMembersAreaPage(editorSDK);
  if (membersAreaPage) {
    await editorSDK.pages.navigateTo(APP_TOKEN, { pageRef: { id: membersAreaPage.id!, type: 'DESKTOP' } });
  }
  return openAddTabsPanel({ editorSDK, eventPayload });
};
